import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  background: theme.color.grey[100],
  '&:nth-of-type(odd)': {
    background: theme.color.grey[300]
  }
}));
